import { fetcher } from "@repo/api";
import { getLanguageAndLocaleFromUrl } from "@repo/translation";
import { type ReactNode, useEffect, useState } from "react";

import { NoAccessPage } from "./NoAccessPage";

export const MarketAccess = ({ children }: { children?: ReactNode }) => {
  const [hasPermission, setHasPermission] = useState(true);

  useEffect(() => {
    if (!window.location.pathname.includes("/restricted")) {
      const { country } = getLanguageAndLocaleFromUrl() ?? {};
      fetcher.global
        .get(`/stores?country=${country?.toUpperCase()}`)
        .catch((err) => {
          if (err?.cause?.code === "RESTRICTED_COUNTRY_ACCESS") {
            setHasPermission(false);
          }
        });
    }
  }, []);

  if (hasPermission) {
    return children;
  }

  return <NoAccessPage />;
};
